import type { UserLevel } from '@/types/site';

export const userLevelToColor = (role: UserLevel) => {
  switch (role) {
    case 'AGENCY_MANAGER':
      return 'bg-purple-100 text-purple-800';
    case 'PUBLIC_OFFICE_MANAGER':
      return 'bg-blue-100 text-blue-800';
    case 'TOWN_MANAGER':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
